import { getMessages } from '../../../../../../store/constants';

export const BOARDS_ADD_BUTTON = getMessages().getText('nav_panel.boards.add');
export const BOARDS_ADD_CREATE = getMessages().getText('nav_panel.boards.create_on_my_drive');
export const BOARDS_ADD_CREATE_FROM_TEMPLATE = getMessages().getText('nav_panel.boards.create_from_template');
export const BOARDS_ADD_IMPORT = getMessages().getText('nav_panel.boards.import');
